import type { ShipmentsTableRequest, ShipmentsTableResponse } from '@/types/shipmentsTable'
import { getAuth } from 'firebase/auth'

export class ShipmentsTableRepository {
  private baseUrl = `${import.meta.env.VITE_CF_BASE_URL}/GET_SHIPMENTS_TABLE`

  private async getAuthToken(): Promise<string> {
    const user = getAuth().currentUser
    if (!user) throw new Error('Usuario no autenticado')
    return user.getIdToken()
  }

  async fetchTable(request: ShipmentsTableRequest): Promise<ShipmentsTableResponse> {
    const token = await this.getAuthToken()

    const response = await fetch(this.baseUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(request)
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Error de conexión con el servidor' }))
      throw new Error(errorData.error || `Error ${response.status} al obtener datos de BigQuery`)
    }

    const result: ShipmentsTableResponse = await response.json()

    if (!result.success) {
      throw new Error((result as any).error || 'Error en la respuesta del servidor')
    }

    return result
  }
}
